module.exports = __webpack_public_path__ + "img/icon-nft.e41ea50a.svg";